// Cascade reel class
//
// Used to create, spin and animate reels
// Contains no logic.
// Set up reels as follows:
//
//    1 - reelmanager.createReel
//    2 - reelmanager.setSymbol to change initial symbols
//
// To use
//
//    1 - Set data using reelmanager.setData(arrayOfSymbolIndexes)
//    2 - reelmanager.startSpin()
//
//
// No injectors needed for this

cascadeReelTemplate = {};

cascadeReelTemplate.popAndDrop = function (symbolIndex, progress, whatSymbols = 'all') {
  var progRad = cascadeReelTemplate.easing(progress);
  // var progRad = cascadeReelTemplate.quadInEasing(progress);
  var pos = this.currentYPos[symbolIndex];

  if (whatSymbols === 'new') {
    if (this.symbolSprites[symbolIndex].droppingInFromOff === true) {
      pos += this.symbolDropDeltas[symbolIndex] * this.configParams.appertureSpacing * progRad;
      pos += this.configParams.appertureSpacing * progRad;
      this.symbolSprites[symbolIndex].position.setY(pos);
      this.posForOrientation[symbolIndex] = pos;
    } else {
      // dont move this one
    }
  } else if (whatSymbols === 'old') {
    if (this.symbolSprites[symbolIndex].droppingInFromOff !== true) {
      pos += this.symbolDropDeltas[symbolIndex] * this.configParams.appertureSpacing * progRad;
      this.symbolSprites[symbolIndex].position.setY(pos);
      this.posForOrientation[symbolIndex] = pos;
    } else {
      // dont move this one
    }
  } else {
    // must be all
    if (this.symbolSprites[symbolIndex].droppingInFromOff === true) {
      pos += this.symbolDropDeltas[symbolIndex] * this.configParams.appertureSpacing * progRad;
      pos += this.configParams.appertureSpacing * progRad;
    } else {
      pos += this.symbolDropDeltas[symbolIndex] * this.configParams.appertureSpacing * progRad;
    }

    this.symbolSprites[symbolIndex].position.setY(pos);

    //set current position and force it back in the orientation change
    this.posForOrientation[symbolIndex] = pos;
  }
};

cascadeReelTemplate.clearSymbols = function (symbolIndex, progress) {
  // Copy from above
  // var progRad = cascadeReelTemplate.easing(progress);
  var progRad = cascadeReelTemplate.quadInEasing(progress);

  // if (symbolIndex == 0) {
  //   var pos = (symbolIndex + 0.5) * (this.configParams.appertureSpacing * 1.5);
  // } else {
  // }
  var pos = (symbolIndex + 0.5) * this.configParams.appertureSpacing;

  pos += this.symbolDropDeltas[symbolIndex] * this.configParams.appertureSpacing * progRad;
  this.symbolSprites[symbolIndex].position.setY(pos);
  this.posForOrientation[symbolIndex] = pos;
};

cascadeReelTemplate.dropInitialSymbols = function (symbolIndex, progress) {
  var progRad = 1 - cascadeReelTemplate.easing(progress);
  // var progRad = 1 - cascadeReelTemplate.quadInEasing(progress);

  // if (symbolIndex == 3) {
  //   var pos = (symbolIndex + 0.5) * (this.configParams.appertureSpacing * 1.1);
  // } else {
  var pos = (symbolIndex + 0.5) * this.configParams.appertureSpacing;
  // }

  if (progRad <= 0) {
    this.playLandSound();
  }

  pos += -(this.symbolDropDeltas[symbolIndex] * this.configParams.appertureSpacing * progRad);
  this.symbolSprites[symbolIndex].position.setY(pos);
  this.posForOrientation[symbolIndex] = pos;
};

cascadeReelTemplate.easing = function (x) {
  // from easings.net
  //     const c4 = (2 * Math.PI) / 3;

  //     return x === 0
  //     ? 0
  //     : x === 1
  //     ? 1
  //     : Math.pow(2, -10 * x) * Math.sin((x * 2- 0.75) * c4) + 1;

  // 2
  const c1 = 0.7; //1.0158;
  const c3 = c1 + 1;
  return 1 + c3 * Math.pow(x - 1, 3) + c1 * Math.pow(x - 1, 2);

  //3
  // let n1 = 7.5625;
  // let d1 = 2.75;

  // if (x < 1 / d1) {
  //     return n1 * x * x;
  // } else if (x < 2 / d1) {
  //     return n1 * (x -= 1.5 / d1) * x + 0.75;
  // } else if (x < 2.5 / d1) {
  //     return n1 * (x -= 2.25 / d1) * x + 0.9375;
  // } else {
  //     return n1 * (x -= 2.625 / d1) * x + 0.984375;
  // }
};
cascadeReelTemplate.linearEasing = function (x) {
  return x;
};

cascadeReelTemplate.quadOutEasing = function (x) {
  return 1 - (1 - x) * (1 - x);
};

cascadeReelTemplate.quadInEasing = function (x) {
  return x * x;
};

cascadeReelTemplate.getDefaultConfigParameters = function () {
  var params = {};
  params.appertureHeight = 5;
  params.preappertureSymbols = 0;
  params.postappertureSymbols = 0;
  params.totalAppertureSize = params.appertureHeight + params.preappertureSymbols + params.postappertureSymbols;

  params.useContainer = {};
  params.useContainer.child = false;

  params.animationStripWidth = 0;
  params.animationStripHeight = 0;

  params.popAndDropTime = 300;
  params.dropAllTime = 500;
  params.dropAllTimeFS = 500;
  params.gapBetweenSymbols = 25;
  params.gapBetweenSymbolsFS = 25;

  params.autoUpdateClipRect = true;

  return params;
};

cascadeReelTemplate.getDefaultSpinParameters = function () {
  var params = {};

  // Acceleration and deceleration unit is "number of symbols"
  params.accelerationDistance = 0;
  params.decelerationDistance = 0;

  // Spin speed and land velocity are in symbols per second
  params.spinSpeed = 9;
  params.landVelocity = 0;

  params.useBounceAnimation = true;
  // Land sound
  params.landSound = undefined;

  // Post land animation
  params.landOffset = 0.25;
  params.landAlignTime = 250;

  params.reverseSpin = false;

  return params;
};

cascadeReelTemplate.setSpinParameters = function (params, json) {
  params.spinSpeed = typeof json.spinSpeed !== 'undefined' ? json.spinSpeed : params.spinSpeed;
  params.landVelocity = typeof json.landVelocity !== 'undefined' ? json.landVelocity : params.landVelocity;
  params.accelerationDistance =
    typeof json.accelerationDistance !== 'undefined' ? json.accelerationDistance : params.accelerationDistance;
  params.decelerationDistance =
    typeof json.decelerationDistance !== 'undefined' ? json.decelerationDistance : params.decelerationDistance;
  params.landOffset = typeof json.landOffset !== 'undefined' ? json.landOffset : params.landOffset;
  params.landAlignTime = typeof json.landAlignTime !== 'undefined' ? json.landAlignTime : params.landAlignTime;
  params.useBounceAnimation =
    typeof json.useBounceAnimation !== 'undefined' ? json.useBounceAnimation : params.useBounceAnimation;
  params.landSound = typeof json.landSound !== 'undefined' ? json.landSound : params.landSound;
  params.renderSymbolsOutOfView =
    typeof json.renderSymbolsOutOfView !== 'undefined' ? json.renderSymbolsOutOfView : params.renderSymbolsOutOfView;

  if (Reflex.developerModeData.fastSpin) {
    params.spinSpeed = 9999;
    params.accelerationDistance = 0;
    params.decelerationDistance = 0;
    params.landAlignTime = 50;
  }

  return params;
};

cascadeReelTemplate.createReel = function (reelIndex, json, landedCallback, droppedCallback) {
  // Create reel object
  var reel = new PIXI.Container();
  reel._stateData = {};

  reel.landSoundPlayed = false;

  reel.symbolData = [];
  reel.symbolSprites = [];
  reel.workingContainer = {};
  reel.dropBasePositions = [];

  reel.reelIndex = reelIndex;
  reel.spinning = false;
  reel.pos = 0;
  reel.preDelay = 0;

  reel.symbolDropDeltas = [];

  reel.linkedAnimations = [];
  reel.linkedReelBoxStrips = [];

  reel.currentYPos = [];

  reel.dropCount = 0;

  reel.dropInitialTimer = [];
  reel.symTimer = [];

  reel.clearTimer = [];
  reel.clearSymTimer = [];
  reel.reelDelayTimer = undefined;
  reel.clearDelayTimer = undefined;

  reel.posForOrientation = [];

  reel.landAnimPool = [];
  reel.landAnimsCreated = [];

  reel._landedCallback = landedCallback;
  reel._droppedCallback = droppedCallback;

  reel._sparkleCoords = {
    5: { x: 48, y: 38 }, // GreenGem
    6: { x: 41, y: 42 }, // PurpleGem
    7: { x: 38, y: 72 }, // RedGem
    8: { x: 35, y: 44 }, // YellowGem
  };
  reel._sparkleCoords2x2 = {
    5: { x: -35, y: -34 }, // GreenGem
    6: { x: -47, y: -28 }, // PurpleGem
    7: { x: -51, y: 29 }, // RedGem
    8: { x: -60, y: -27 }, // YellowGem
  };
  // reel._sparkleCoords3x3 = {
  //   5: { x: 48, y: 38 }, // GreenGem
  //   6: { x: 41, y: 42 }, // PurpleGem
  //   7: { x: 38, y: 72 }, // RedGem
  //   8: { x: 35, y: 44 }, // YellowGem
  // };

  reel._dropSymbolsAnticipationSounds = [
    'dropSymbolsAnticipation1',
    'dropSymbolsAnticipation2',
    'dropSymbolsAnticipation3',
    'dropSymbolsAnticipation4',
    'dropSymbolsAnticipation5',
  ];
  reel._lastRandomDropSymbolAnticipationSoundIndex = -1;

  reel._awardEggMultiplierSounds = [
    'revealAndMoveSymbolMuliplier1',
    'revealAndMoveSymbolMuliplier2',
    'revealAndMoveSymbolMuliplier3',
  ];
  reel._lastRandomAwardEggMultiplierSoundIndex = -1;

  reel._moveMultiplierTextTweenInfo = {};
  reel._moveGoldMultiplierTextTweenInfo = {};
  reel._scaleMultiplierTextTweenInfo = {};
  reel._scaleGoldMultiplierTextTweenInfo = {};

  // reel._cascadeSounds = ['cascade1', 'cascade2', 'cascade3'];

  // The symbols template tells us all about the reel symbols
  var symbolTemplate = resourceManager.getConfiguration().symbols;
  var keys = Object.keys(symbolTemplate);

  // Get configuration parameters used for this template (cant change)
  reel.configParams = cascadeReelTemplate.getDefaultConfigParameters();
  if (typeof json.appertureHeight !== 'undefined') {
    reel.configParams.appertureHeight = json.appertureHeight;
  }
  if (typeof json.preappertureSymbols !== 'undefined') {
    reel.configParams.preappertureSymbols = json.preappertureSymbols;
  }
  if (typeof json.postappertureSymbols !== 'undefined') {
    reel.configParams.postappertureSymbols = json.postappertureSymbols;
  }
  if (typeof json.popAndDropTime !== 'undefined') {
    reel.configParams.popAndDropTime = json.popAndDropTime;
  }
  if (typeof json.dropAllTime !== 'undefined') {
    reel.configParams.dropAllTime = json.dropAllTime;
  }

  if (typeof json.autoUpdateClipRect !== 'undefined') {
    reel.configParams.autoUpdateClipRect = json.autoUpdateClipRect;
  }

  reel.configParams.totalAppertureSize =
    reel.configParams.preappertureSymbols + reel.configParams.appertureHeight + reel.configParams.postappertureSymbols;

  // Create spin parameters used for this reel (can change)
  reel.spinParams = cascadeReelTemplate.setSpinParameters.bind(reel)(
    cascadeReelTemplate.getDefaultSpinParameters(),
    json
  );

  var symbolTextures = textureParser.getTextureList('staticSymbols');
  var initialSymbols = [];
  for (var i = 0; i < reel.configParams.totalAppertureSize; ++i) {
    initialSymbols.push({
      symbolId: 0,
    });
  }

  // Create object to store all speed parameters neatly
  reel.speedData = {};
  reel.symbolLUT = {};

  // Create look up table
  for (var i = 0; i < keys.length; i++) {
    var symbolDef = symbolTemplate[keys[i]];
    reel.symbolLUT['ID' + symbolDef.ID] = i;
  }

  reel.saveState = function () {
    this._stateData = {};
    var keys = Object.getOwnPropertyNames(this);
    var keysToIgnore = Object.keys(new PIXI.Container());

    // These are all PIXI objects
    keysToIgnore.push('symbolSprites');
    keysToIgnore.push('linkedAnimations');
    keysToIgnore.push('linkedReelBoxStrips');
    keysToIgnore.push('symbolContainer');
    keysToIgnore.push('interactiveSymbolContainer');
    keysToIgnore.push('animationStripContainer');
    keysToIgnore.push('animationBoxContainer');
    keysToIgnore.push('workingContainer');

    // These arent saved change
    keysToIgnore.push('Props');
    keysToIgnore.push('stateMachine');
    keysToIgnore.push('phase');
    keysToIgnore.push('_stateData');
    // keysToIgnore.push("preInjector");
    //  keysToIgnore.push("postInjector");

    for (var i = 0; i < keysToIgnore.length; i++) {
      keys.splice(keys.indexOf(keysToIgnore[i]), 1);
    }

    for (var i = 0; i < keys.length; i++) {
      var name = keys[i];
      var type = typeof this[name];
      var isCallback = name.includes('callback') || name.includes('Callback');

      if (type !== 'function' && name !== 'base' && !isCallback) {
        if (checkForDefined(this[name])) {
          this._stateData[keys[i]] = JSON.parse(JSON.stringify(this[name]));
        } else {
          this._stateData[keys[i]] = undefined;
        }
      }
    }
  };

  reel.restoreState = function () {
    // ABORT FUNCTIONALITY - leave in in case somone changes thier mind

    // var keys = Object.keys(this._stateData);
    // for (var i = 0; i < keys.length; i++) {
    //     var name = keys[i];
    //     if (checkForDefined(this._stateData[name])) {
    //         this[name] = JSON.parse(JSON.stringify(this._stateData[name]));
    //     }
    //     else {
    //         this[name] = undefined;
    //     }
    // }

    // // Reset symbol sprites
    // for (var i = 0; i < this.symbolData.length; i++) {
    //     this.setReelSymbol(i - reel.configParams.preappertureSymbols, this.symbolData[i]);
    // }

    /////////////////////////////////////////////////////////////////////////////////////////////////////////

    // shut down all timers
    // timer for this reel to drop in

    if (this.clearDelayTimer !== undefined) {
      timerManager.stop(this.clearDelayTimer);
      this.clearDelayTimer = undefined;
    }

    // timers for each symbol to wait before drop
    for (var i = 0; i < this.clearTimer.length; i++) {
      if (this.clearTimer[i] !== undefined) {
        timerManager.stop(this.clearTimer[i]);
        this.clearTimer[i] = undefined;
      }
    }

    // timers for each symbol to drop into position
    for (var i = 0; i < this.clearSymTimer.length; i++) {
      if (this.clearSymTimer[i] !== undefined) {
        timerManager.stop(this.clearSymTimer[i]);
        this.clearSymTimer[i] = undefined;
      }
    }

    this.stateMachine.switchState('READY');
    this._stateData = {};
  };

  reel.clearReel = function (delay) {
    let self = this;

    // in view
    reel.symbolDropDeltas[0] = 6;
    reel.symbolDropDeltas[1] = 6;
    reel.symbolDropDeltas[2] = 6;
    reel.symbolDropDeltas[3] = 6;
    reel.symbolDropDeltas[4] = 6;

    // post
    reel.dropCount = 5;

    for (var i = 0; i < this.symbolSprites.length; i++) {
      this.symbolSprites[i].droppingInFromOff = false;
      this.posForOrientation[i] = undefined;
    }

    this.clearDelayTimer = timerManager.addTimer(
      delay,
      function (progress) {},
      function () {
        self.stateMachine.switchState('CLEARSYMBOLS');
      }
    );
  };

  reel.fillInitialSymbols = function (delay, positions, eggMultiplierData = null, colossalData = null) {
    this.slamStopRequested = false;
    // need to swap out symbols with those in positions before dropping in
    let self = this;

    // in view
    reel.symbolDropDeltas[0] = 6;
    reel.symbolDropDeltas[1] = 6;
    reel.symbolDropDeltas[2] = 6;
    reel.symbolDropDeltas[3] = 6;
    reel.symbolDropDeltas[4] = 6;

    const eggMultipliers = [1, 1, 1, 1, 1]; // default to 1
    if (eggMultiplierData !== null) {
      // now we need to see if we have any info for this reel
      for (let i = 0; i < eggMultiplierData.length; i++) {
        if (eggMultiplierData[i].position.reel === this.reelIndex) {
          eggMultipliers[eggMultiplierData[i].position.offset] = eggMultiplierData[i].multiplier;
        }
      }
    }

    // post
    reel.setSymbol(0, positions[this.reelIndex][0], eggMultipliers[0], colossalData);
    reel.setSymbol(1, positions[this.reelIndex][1], eggMultipliers[1], colossalData);
    reel.setSymbol(2, positions[this.reelIndex][2], eggMultipliers[2], colossalData);
    reel.setSymbol(3, positions[this.reelIndex][3], eggMultipliers[3], colossalData);
    reel.setSymbol(4, positions[this.reelIndex][4], eggMultipliers[4], colossalData);

    reel.dropCount = 5;

    for (var i = 0; i < this.symbolSprites.length; i++) {
      this.posForOrientation[i] = undefined;
    }

    // Move the non-visible symbols down so the oversized ones don't creep up onto the reels
    // this.symbolSprites[0].position.setY(1000);

    reel.reparentAllSymbolsToOriginalParents();
    reel.parentAllOversizedSymbols();

    this.reelDelayTimer = timerManager.addTimer(
      delay,
      function (progress) {},
      function () {
        self.stateMachine.switchState('DROPINITIALSYMBOLS');
      }
    );
  };

  reel.requestSlamStop = function () {
    this.slamStopRequested = true;
    // needs to put all symbols into final position
    // update symbols to correct final symbol
    // clear all timers that are in progress and reset states

    // landing call backs must all be called correctly too.

    // don't slam out pops - or special symbols

    // clear symbols
    // initial drop slamout only.

    // initial delay timers and symbols timers - stop timers - set progress to 100%

    // timer for this reel to drop in
    if (this.reelDelayTimer !== undefined) {
      timerManager.stop(this.reelDelayTimer);
      this.reelDelayTimer = undefined;
    }

    // timers for each symbol to wait before drop
    for (var i = 0; i < this.symTimer.length; i++) {
      if (this.symTimer[i] !== undefined) {
        timerManager.stop(this.symTimer[i]);
        this.symTimer[i] = undefined;
      }
    }

    // timers for each symbol to drop into position
    for (var i = 0; i < this.dropInitialTimer.length; i++) {
      if (this.dropInitialTimer[i] !== undefined) {
        timerManager.stop(this.dropInitialTimer[i]);
        this.dropInitialTimer[i] = undefined;
      }
    }

    // fire all the call backs and set drop count to zero
    for (var i = 4; i >= 0; i--) {
      this.landSoundPlayed = true; // stop slam stop playing all the sounds at once
      this.dropInitialSymbols(i, 1);
      this.parentAllOversizedSymbols(i, true);
      this._landedCallback(this.reelIndex, i);
    }

    // force this here as we may not have made it into drop initial symbols
    this.stateMachine.switchState('READY');
    this.spinning = false;
    this.spinCompleteCallback(this.reelIndex);

    this.dropCount = 0;

    //reel.alpha = 1;
  };

  // reel.checkSlamStop = function() {
  //     if (this.slamStopRequested) {
  //         // // Get all remaining symbol out the injector. Note we dont have to create every symbol, so first dump everything that will go in the apperture
  //         // while (this.postInjector.remainingSymbols > (this.configParams.appertureHeight + this.configParams.preappertureSymbols + this.configParams.postappertureSymbols)) {
  //         //     this.postInjector.getNextSymbol(this.symbolData);
  //         // }

  //         // while (this.postInjector.remainingSymbols > 0) {
  //         //     this.getNextSymbolFromInjector(this.postInjector);
  //         // }

  //         // Update positions to rest
  //         this.pos = 0;
  //         this.updateSymbols();

  //         // Go to just landed state to continue
  //         this.stateMachine.switchState("JUST_LANDED");

  //         return true;
  //     };

  //     return false;
  // };

  reel.requestStop = function () {
    this.stopRequested = true;
  };

  reel.stop = function (positions, numberPreSymbols) {
    this.stateMachine.switchState('SPINNING');
    this.updatePos = cascadeReelTemplate.defaultSpin.bind(this);
  };

  reel.setSpinParameters = function (spinParameters) {
    // spin Parameters should be passed as an object
    cascadeReelTemplate.setSpinParameters.bind(this)(this.spinParams, spinParameters);
  };

  reel.spinDeceleratingCallback = function () {};

  reel.spinLandedCallback = function () {};

  reel.spinCompleteCallback = function () {};

  reel.initialDropCompleteCallback = function () {};

  reel.nudgeOnComplete = function () {};
  reel.Props = {};

  reel.Props.state = 'READY';
  reel.Props.stateTime = 0;

  // Create data
  reel.symbolWidth = symbolTextures[0].width;
  reel.symbolHeight = symbolTextures[0].height;

  // These sizes are in standard layout space
  reelManager.symbolWidth = symbolTextures[0].width;
  reelManager.symbolHeight = symbolTextures[0].height;

  reel.configParams.appertureSpacing = checkForDefined(json.appertureSpacing)
    ? json.appertureSpacing
    : reel.symbolHeight;
  reel.configParams.viewportWidth = checkForDefined(json.viewportWidth)
    ? json.viewportWidth / resourceManager.selectedAssetResolution.scaleFactor
    : reel.symbolWidth;
  reel.configParams.viewportHeight = checkForDefined(json.viewportHeight)
    ? json.viewportHeight / resourceManager.selectedAssetResolution.scaleFactor
    : reel.configParams.appertureSpacing * reel.configParams.appertureHeight;
  reel.configParams.viewportOffsetX = (reel.configParams.viewportWidth - reelManager.symbolWidth) / 2;

  if (checkForDefined(json.useContainer)) {
    reel.configParams.useContainer.child = checkForDefined(json.useContainer.child)
      ? json.useContainer.child
      : reel.configParams.useContainer.child;
  }

  reel.configParams.animationStripWidth = checkForDefined(json.animationStripWidth)
    ? json.animationStripWidth
    : reel.configParams.viewportWidth;
  reel.configParams.animationStripHeight = checkForDefined(json.animationStripHeight)
    ? json.animationStripHeight
    : reel.configParams.viewportHeight;

  // Set up background
  if (typeof json.backgroundColour !== 'undefined') {
    var backgroundFill = new PIXI.Graphics();
    backgroundFill.beginFill(json.backgroundColour, 1);
    backgroundFill.drawRect(0, 0, reel.symbolWidth, reel.symbolHeight * reel.configParams.appertureHeight);
    backgroundFill.endFill();
    reel.addChildAt(backgroundFill, 0);
  }

  reel.symbolSize = [];

  reel.initialise = function (json) {
    reel.symbolContainer = resourceManager.createObject('container', 'symbolContainer', json.FQN, {
      //Move symbols within clip area
      x: (reel.configParams.viewportWidth / 2) * resourceManager.selectedAssetResolution.scaleFactor,
      y: 0,
    });

    reel.symbolContainer.parent.removeChild(reel.symbolContainer);

    reel.interactiveSymbolContainer = new PIXI.Graphics();
    reel.interactiveSymbolContainer.interactive = true;

    reel.interactiveSymbolContainer.mousedown = function (eventData) {
      //Convert the mouse position to be relative to the reel
      var point = eventData.data.getLocalPosition(this);
      //Get the selected index
      var index = Math.floor(point.y / reel.configParams.appertureSpacing);
      index += reel.configParams.preappertureSymbols;

      //Invoke the mousedown event on the selected symbol
      if (reel.symbolSprites[index].symbol.interactive && reel.symbolSprites[index].symbol.mousedown !== undefined)
        reel.symbolSprites[index].symbol.mousedown(eventData);
    };

    reel.interactiveSymbolContainer.beginFill(0x000000, 0);
    reel.interactiveSymbolContainer.drawRect(0, 0, reel.configParams.viewportWidth, reel.configParams.viewportHeight);
    reel.addChild(reel.symbolContainer);

    // reel.mask = new PIXI.Graphics();
    // reel.mask.beginFill(0x000000, 0);
    // reel.mask.drawRect(0, 0, reel.configParams.viewportWidth + 1, reel.configParams.viewportHeight + 1);
    // reel.mask.endFill();
    // reel.addChild(reel.mask);

    // loop through and create reel symbols
    for (let i = 0; i < reel.configParams.totalAppertureSize; i++) {
      var newSymbolContainer = resourceManager.createObject('container', 'symbol' + i, reel.symbolContainer.name, {
        x: 0,
        y: (i + 0.5) * reel.configParams.appertureSpacing,
      });

      newSymbolContainer.index = i;

      newSymbolContainer.symbol = resourceManager.createObject('movie', 'symbol', newSymbolContainer.name, {
        x: 0,
        y: 0,
        definition: 'staticSymbols',
        cloneTextures: true,
      });

      // sparkles can be added
      newSymbolContainer.symbolSparkle = resourceManager.createObject('sprite', 'sparkle', newSymbolContainer.symbol, {
        fileName: 'Symbols/Gems/Symbol_Sparkle/Symbol_Gem_Sparkle.png',
        x: 0,
        y: 0,
        anchor: 0.5,
      });
      newSymbolContainer.symbolSparkle.visible = false;
      newSymbolContainer.symbol.removeChild(newSymbolContainer.symbolSparkle);

      newSymbolContainer.eggBurst = resourceManager.createObject('sprite', 'Egg_Burst', newSymbolContainer.name, {
        x: 0,
        y: 0,
        fileName: 'Beanstalk/Golden_Egg/Egg_Burst.png',
        anchor: 0.5,
      });
      newSymbolContainer.eggBurst.visible = false;
      newSymbolContainer.symbol.removeChild(newSymbolContainer.eggBurst);

      newSymbolContainer.smallEggWinMovie = resourceManager.createObject(
        'movie',
        'smallEggWinMovie',
        newSymbolContainer.name,
        {
          x: 0,
          y: 0,
          anchor: 0.5,
          definition: 'GoldenEggSmallWin20fps_md',
          loop: false,
        }
      );
      newSymbolContainer.smallEggWinMovie.visible = false;
      newSymbolContainer.symbol.removeChild(newSymbolContainer.smallEggWinMovie);

      newSymbolContainer.largeEggWinMovie = resourceManager.createObject(
        'movie',
        'largeEggWinMovie',
        newSymbolContainer.name,
        {
          x: 0,
          y: 0,
          anchor: 0.5,
          definition: 'GoldenEggLargeWin20fps_md',
          loop: false,
        }
      );
      newSymbolContainer.largeEggWinMovie.visible = false;
      newSymbolContainer.symbol.removeChild(newSymbolContainer.largeEggWinMovie);

      newSymbolContainer.wildIdleMovie = resourceManager.createObject(
        'movie',
        'wildIdleMovie',
        newSymbolContainer.name,
        {
          x: 0,
          y: 0,
          anchor: 0.5,
          definition: 'WildIdle_md',
          loop: false,
        }
      );
      newSymbolContainer.wildIdleMovie.visible = false;
      newSymbolContainer.symbol.removeChild(newSymbolContainer.wildIdleMovie);

      // we need a bitmap font for gold eggs
      // SRB TODO again create them but remove from scene graph and add back on only when required
      newSymbolContainer.eggMultiplierText = resourceManager.createObject(
        'text',
        'eggMultiplierText',
        newSymbolContainer.symbol,
        {
          x: 0,
          y: 0,
          anchor: 0.5,
          fontDefinition: 'Symbol_Egg_Font_Bonus',
          maxWidth: 130,
        }
      );
      newSymbolContainer.eggMultiplierText.visible = false;
      newSymbolContainer.symbol.removeChild(newSymbolContainer.eggMultiplierText);

      newSymbolContainer.eggMultiplierGoldText = resourceManager.createObject(
        'text',
        'eggMultiplierGoldText',
        newSymbolContainer.symbol,
        {
          x: 0,
          y: 0,
          anchor: 0.5,
          fontDefinition: 'Symbol_Egg_Font_Bonus_Gold',
          maxWidth: 130,
        }
      );
      newSymbolContainer.eggMultiplierGoldText.visible = false;
      newSymbolContainer.symbol.removeChild(newSymbolContainer.eggMultiplierGoldText);

      newSymbolContainer.eggAwardSparksMovie = resourceManager.createObject(
        'movie',
        'eggAwardSparksMovie',
        newSymbolContainer.symbol,
        {
          x: 0,
          y: 0,
          anchor: 0.5,
          scale: 2.5,
          loop: false,
          definition: 'EggAwardSparksMovie',
        }
      );
      newSymbolContainer.eggAwardSparksMovie.visible = false;
      newSymbolContainer.symbol.removeChild(newSymbolContainer.eggAwardSparksMovie);

      if (reel.configParams.useContainer.child) {
        newSymbolContainer.symbol.childContainer = resourceManager.createObject(
          'container',
          'childContainer',
          newSymbolContainer.symbol.name,
          {
            x: 0,
            y: 0,
          }
        );
      }

      newSymbolContainer.dimReelsCanvas = resourceManager.createObject(
        'graphics',
        'dimReelsCanvas',
        newSymbolContainer.name,
        {
          x: 0,
          y: 0,
        }
      );

      newSymbolContainer.dimReelsCanvas.beginFill(0x000000);
      newSymbolContainer.dimReelsCanvas.drawRect(
        -(reel.configParams.viewportWidth + 1) / 2,
        -(reel.configParams.viewportHeight + 1) / 2,
        reel.configParams.viewportWidth + 1,
        reel.configParams.viewportHeight + 1
      );
      newSymbolContainer.dimReelsCanvas.endFill();
      newSymbolContainer.dimReelsCanvas.alpha = 0.6;
      newSymbolContainer.dimReelsCanvas.visible = false;

      newSymbolContainer.symbol.anchor.set(0.5, 0.5);
      newSymbolContainer.symbol.gotoAndStop(initialSymbols[i].symbolId);

      reel.symbolData.push(initialSymbols[i]);
      reel.symbolSprites.push(newSymbolContainer);
      newSymbolContainer.symbol.symbolIndex = i;
      newSymbolContainer.symbol.parentReel = reel;

      // Confirm all files loaded
      for (let j = 0; j < newSymbolContainer.symbol.textures.length; j++) {
        if (!newSymbolContainer.symbol.textures[j].baseTexture.hasLoaded) {
          console.log(
            'Texture index ' +
              j +
              ' for symbol ' +
              Object.keys(resourceManager.getConfiguration().symbols)[j] +
              ' was not loaded'
          );
          return;
        }
      }

      // Store original UV'. We only do this for the first symbol in the animation movie, as this is the one we spin past.
      if (i === 0) {
        for (let j = 0; j < newSymbolContainer.symbol.textures.length; j++) {
          reel.symbolSize.push({
            width: newSymbolContainer.symbol.textures[j].frame.width,
            height: newSymbolContainer.symbol.textures[j].frame.height,
          });
        }
      }
    }

    for (let i = 0; i < this.symbolData.length; i++) {
      reel.symbolDropDeltas.push(0);
    }

    if (reel.configParams.useContainer.child) {
      // A container to use as temporary storage when adjusting the symbols as part of getNextSymbolFromInjector
      reel.workingContainer = resourceManager.createObject('container', 'workingContainer', newSymbolContainer.name, {
        x: 0,
        y: 0,
      });
    }

    // A container to hold all of the animation strips for this reel
    reel.animationStripContainer = resourceManager.createObject('container', 'animationStripContainer', json.FQN, {
      x: 0,
      y: 0,
    });
    reel.animationStripContainer.parent.removeChild(reel.animationStripContainer);
    reel.animationStripContainer.scale.set(1.0, 1.0);

    /*
        reel.animationStripContainer.mask = new PIXI.Graphics();
        reel.animationStripContainer.mask.beginFill(0x000000, 0);
        reel.animationStripContainer.mask.drawRect(-reel.configParams.viewportWidth / 2, 0, reel.configParams.viewportWidth + 1, reel.configParams.viewportHeight + 1);
        reel.animationStripContainer.mask.endFill();
        reel.animationStripContainer.addChild(reel.animationStripContainer.mask);
        */

    // A container to hold all of the animation box strip for this reel
    reel.animationBoxContainer = resourceManager.createObject('container', 'animationBoxContainer', json.FQN, {
      x: 0,
      y: 0,
    });
    reel.animationBoxContainer.parent.removeChild(reel.animationBoxContainer);

    for (let i = 0; i < reel.symbolSprites.length; i++) {
      reel.symbolSprites[i].originalParent = reel.symbolSprites[i].parent;
    }
  };

  reel.onTouched = function () {
    this.touchedCallback(this.parentReel.reelIndex, this.symbolIndex - reel.configParams.preappertureSymbols);
  };

  reel.setTouchCallback = function (index, callback) {
    index += reel.configParams.preappertureSymbols;
    const symbol = reel.symbolSprites[index].symbol;
    symbol.interactive = true;
    symbol.mousedown = symbol.touchstart = reel.onTouched;
    symbol.touchedCallback = callback;
  };

  reel.clearTouchCallback = function (index) {
    reel.symbolSprites[index + reel.configParams.preappertureSymbols].symbol.interactive = false;
  };

  reel.setReelSymbol = function (index, symbolData) {
    var spriteIndex = index + reel.configParams.preappertureSymbols;
    this.clearReelSymbolData(spriteIndex);
    this.setReelSymbolData(spriteIndex, symbolData);
    this.pos = 0.99999;
    this.updateSymbols();
    var symbol = this.symbolData[spriteIndex].ID;

    if (reel.anySymbolCreatedCallback !== undefined) {
      reel.anySymbolCreatedCallback(this.reelIndex, symbol, spriteIndex);
    }
    if (reel.symbolCreatedCallbacks[symbol] !== undefined) {
      reel.symbolCreatedCallbacks[symbol](this.reelIndex, symbol, spriteIndex);
    }
  };

  reel.forceEggSymbolMultiplier = function (index, eggMultiplier) {
    const symbol = eggMultiplier >= 20 ? 21 : 20;
    this.symbolSprites[index].eggMultiplier = eggMultiplier;
    this.symbolData[index].eggMultiplier = eggMultiplier;
    this.symbolSprites[index].eggMultiplierText.setText(`${eggMultiplier}x`);
    this.symbolSprites[index].eggMultiplierGoldText.setText(`${eggMultiplier}x`);
    if (symbol === 21) {
      this.symbolSprites[index].eggMultiplierText.visible = false;
      this.symbolSprites[index].eggMultiplierGoldText.visible = true;
    } else {
      this.symbolSprites[index].eggMultiplierText.visible = true;
      this.symbolSprites[index].eggMultiplierGoldText.visible = false;
    }
    this.symbolSprites[index].symbol.gotoAndStop(symbol);
    this.symbolData[index].symbolId = symbol;
  };

  reel.animateRemovalOfColossalSymbols = async function (colossalData) {
    // look for colossal symbols which need fading out and an emitter playing over the top
    // of it
    reel.emittersUsedForRemoval = [];
    const promises = [];
    const stage = systemData.stage;
    const slotMachine = GameSlotMachineFactory.getSlotMachine(0);
    for (let i = 0; i < colossalData.length; i++) {
      if (colossalData[i] && colossalData[i].spriteHere === true) {
        let emitter = null;
        let xyOffset = { x: 0, y: 0 };
        if (colossalData[i].size === 3) {
          emitter = slotMachine.grabUnused3x3Emitter();
          xyOffset.x = -110; // symbol width
          xyOffset.y = -110; // symbol width
        } else {
          emitter = slotMachine.grabUnused2x2Emitter();
          xyOffset.x = 0;
          xyOffset.y = 0;
        }

        if (emitter) {
          reel.emittersUsedForRemoval.push(emitter);
          const globalPos = this.symbolSprites[i].symbol.toGlobal(stage);
          const newPos = resourceManager.get('slotContainer:particlesContainer').toLocal(globalPos);

          emitter.x = newPos.x + xyOffset.x;
          emitter.y = newPos.y + xyOffset.y;

          emitter.origParent.addChild(emitter);
          emitter.particleEmitter.emit = true;
          emitter.visible = true;
        }

        promises.push(
          game.tweenFromToAsync(
            this.symbolSprites[i].symbol,
            {
              alpha: 1,
            },
            {
              alpha: 0,
              delay: 0.2,
              duration: 0.2,
              ease: 'none',
            }
          )
        );
      }
    }

    // wait for all symbols on this reel to fade out
    await Promise.all(promises);
  };

  reel.revealSmallerAfterColossalSymbols = async function (colossalData) {
    const slotMachine = GameSlotMachineFactory.getSlotMachine(0);
    const promises = [];
    const emittersUsed = [];
    const stage = systemData.stage;
    for (let i = 0; i < this.symbolSprites.length; i++) {
      const symbolSprite = this.symbolSprites[i];
      const symbol = this.symbolData[i].symbolId;
      let animate = false;
      if (colossalData[i] && colossalData[i].spriteHere === true) {
        symbolSprite.symbol.anchor.set(0.5);
        symbolSprite.symbol.gotoAndStop(symbol);
        animate = true;
      } else if (symbolSprite.symbol.visible === false) {
        animate = true;
      }

      if (animate) {
        // now just scale and fade in
        symbolSprite.symbol.scale.set(0);
        symbolSprite.symbol.alpha = 0;
        symbolSprite.symbol.visible = true;

        let emitter = slotMachine.grab1x1Emitter(reel.reelIndex, i);
        let xyOffset = { x: 0, y: 0 };
        const globalPos = symbolSprite.symbol.toGlobal(stage);
        const newPos = resourceManager.get('slotContainer:particlesContainer').toLocal(globalPos);

        emitter.x = newPos.x + xyOffset.x;
        emitter.y = newPos.y + xyOffset.y;

        emittersUsed.push(emitter);

        promises.push(
          game.tweenFromToAsync(
            symbolSprite.symbol.scale,
            {
              x: 0,
              y: 0,
            },
            {
              x: 1,
              y: 1,
              duration: 0.25,
              ease: 'power1.in',
            }
          )
        );
        promises.push(
          game.tweenFromToAsync(
            symbolSprite.symbol,
            {
              alpha: 0,
            },
            {
              alpha: 1,
              duration: 0.1,
            }
          )
        );
      }
    }

    // now wait for them to finish scaling in
    await Promise.all(promises);

    // emitters want to animate now
    for (let i = 0; i < emittersUsed.length; i++) {
      const emitter = emittersUsed[i];
      emitter.particleEmitter.emit = true;
      emitter.visible = true;
      emitter.origParent.addChild(emitter);
    }

    await timerManager.delayAsync(300);

    for (let i = 0; i < reel.emittersUsedForRemoval.length; i++) {
      const emitter = reel.emittersUsedForRemoval[i];
      emitter.particleEmitter.emit = false;
      emitter.visible = false;
      emitter.parent.removeChild(emitter);
    }

    for (let i = 0; i < emittersUsed.length; i++) {
      const emitter = emittersUsed[i];
      emitter.particleEmitter.emit = false;
      emitter.visible = false;
      emitter.parent.removeChild(emitter);
    }
  };

  reel.setSymbol = function (index, symbol, eggMultiplier, colossalData) {
    // TODO SA 12/04    index += reel.configParams.preappertureSymbols;
    // Change the symbol and the underlying data

    const symbolSprite = this.symbolSprites[index];

    // whats our symbol?
    // is it 20?
    // if so we need to know what the multiplier is
    if (symbol === 20) {
      // have we been passed a valid multiplier?
      if (eggMultiplier > 1) {
        // we have a valid multiplier
        // fine leave as is
      } else {
        // nope
        // have we already been assigned one?
        if (typeof symbolSprite.eggMultiplier === 'undefined' || symbolSprite.eggMultiplier === 1) {
          // no we havent
          // use the min from bgTrail?
          const _bgTrail = resourceManager.get('bgTrail:BGTrailContainer');
          eggMultiplier = _bgTrail.getMinMultiplier();
        } else {
          // yes we have
          // we can use that one
          eggMultiplier = symbolSprite.eggMultiplier;
        }
      }

      // we should have the correct multiplier by now
      // now should we update the egg
      if (typeof symbolSprite.eggMultiplier === 'undefined' || symbolSprite.eggMultiplier < 2) {
        // we need to assign this multiplier to this egg
        symbolSprite.eggMultiplier = eggMultiplier;
        this.symbolData[index].eggMultiplier = eggMultiplier;
        symbolSprite.eggMultiplierText.setText(`${eggMultiplier}x`);
        symbolSprite.eggMultiplierGoldText.setText(`${eggMultiplier}x`);

        if (eggMultiplier >= 20) {
          // upgrade to the bigger egg
          symbol = 21;
          symbolSprite.eggMultiplierText.visible = false;
          symbolSprite.eggMultiplierGoldText.visible = true;
        } else {
          symbolSprite.eggMultiplierText.visible = true;
          symbolSprite.eggMultiplierGoldText.visible = false;
        }
        symbolSprite.eggMultiplierText.tint = symbol.tint;
        symbolSprite.eggMultiplierGoldText.tint = symbol.tint;
        symbolSprite.addChild(symbolSprite.eggMultiplierText);
        symbolSprite.addChild(symbolSprite.eggMultiplierGoldText);
      } else {
        // leave this alone, its been set up
        // but we still need to alter the symbol if the multiplier is greater than 20
        if (symbolSprite.eggMultiplier >= 20) {
          symbol = 21;
        }
      }
    } else {
      symbolSprite.eggMultiplier = undefined;
      this.symbolData[index].eggMultiplier = undefined;
      symbolSprite.eggMultiplierText.setText('');
      symbolSprite.eggMultiplierGoldText.setText('');
      symbolSprite.eggMultiplierText.visible = false;
      symbolSprite.eggMultiplierGoldText.visible = false;
      symbolSprite.removeChild(symbolSprite.eggMultiplierText);
      symbolSprite.removeChild(symbolSprite.eggMultiplierGoldText);
    }

    let colossalSymbolIndexOffset = 0;
    symbolSprite.symbol.visible = true;
    symbolSprite.symbol.scale.set(1);
    symbolSprite.symbol.anchor.set(0.5);
    symbolSprite.symbol.colossal = 1;

    // is this symbol supposed to be temporarily a colossal symbol?
    // we can find out from colossalData which is passed in
    if (colossalData && colossalData[reel.reelIndex][index]) {
      if (colossalData[reel.reelIndex][index].spriteHere === true) {
        if (colossalData[reel.reelIndex][index].size === 2) {
          colossalSymbolIndexOffset += 22;
          symbolSprite.symbol.anchor.set(0.75);
          symbolSprite.symbol.colossal = 2;
        } else {
          // must be a 3x3
          colossalSymbolIndexOffset += 32;
          symbolSprite.symbol.anchor.set(0.83);
          symbolSprite.symbol.colossal = 3;
        }
      } else {
        // we are part of a colossal
        symbolSprite.symbol.visible = false;
      }
    }

    symbolSprite.symbol.gotoAndStop(symbol + colossalSymbolIndexOffset);
    this.symbolData[index].symbolId = symbol;
    this.stopSparkle(symbolSprite.symbolSparkle);

    if (reel.anySymbolCreatedCallback !== undefined) {
      reel.anySymbolCreatedCallback(this.reelIndex, symbol, index);
    }
    if (reel.symbolCreatedCallbacks[index] !== undefined) {
      reel.symbolCreatedCallbacks[index](this.reelIndex, symbol, index);
    }
  };

  reel.getSymbol = function (index) {
    return this.symbolData[index + reel.configParams.preappertureSymbols].symbolId;
  };

  reel.showSymbol = function (index, show) {
    // var symbolSpriteIndex = index + reel.configParams.preappertureSymbols;
    this.symbolSprites[index].symbol.visible = show;
  };

  reel.growSymbol = function (index) {
    this.symbolSprites[index].symbol.visible = true;
    gsap.fromTo(
      this.symbolSprites[index].symbol.scale,
      {
        x: 0,
        y: 0,
      },
      {
        duration: 0.4,
        delay: 0.2,
        x: 1,
        y: 1,
        ease: 'back.out(1.7)',
      }
    );
  };

  reel.setSpinner = function (spinnerFunction) {
    this.updatePos = spinnerFunction.bind(this);
  };

  reel.popSymbols = function (symbolsToPop, newSymbols, eggMultipliers) {
    // Note it is up to the game programmer to set the symbols that are dropping in before calling this function
    for (var i = 0; i < this.symbolData.length; i++) {
      this.symbolDropDeltas[i] = 0;
    }

    // this.symbolDropDeltas[3] = 0;

    var symbolsPopped = 0;
    var lastSymbolToPopIndex = symbolsToPop.length - 1;
    for (var i = symbolsToPop.length - 1; i >= 0; --i) {
      if (symbolsToPop[i]) {
        symbolsPopped++;
      } else {
        this.symbolDropDeltas[lastSymbolToPopIndex--] = symbolsPopped;
      }
    }

    // Fill in all the above symbols so they are also dropped
    for (var i = 0; i <= lastSymbolToPopIndex; ++i) {
      if (!this.symbolDropDeltas[i]) {
        this.symbolDropDeltas[i] = symbolsPopped;
      }
    }

    // how many symbols are we popping on this reel - needed to calc the new position to drop from
    var numTrue = 0;
    for (var i = 0; i < 5; i++) {
      this.symbolSprites[i].droppingInFromOff = false;
      if (symbolsToPop[i] === true) {
        this.symbolSprites[i].droppingInFromOff = true;
        numTrue++;
      }
    }

    // for symbols that are popping we move them above the visible reel frame ready to drop in
    var index = numTrue;
    for (var i = 0; i < 5; i++) {
      if (symbolsToPop[i] === true) {
        let yPos = 0.5 * this.configParams.appertureSpacing + -index * this.configParams.appertureSpacing;
        yPos -= this.configParams.appertureSpacing;
        this.symbolSprites[i].position.setY(yPos);
        index--;
      }
    }

    // the 4th unused except for initial drop - set Y way out of bounds for sort - though this position should be at the end anyway
    // this.symbolSprites[3].position.setY(1000);

    // sort the sprites and symbol data - any popped symbols are now in the correct order
    for (var i = 0; i < this.symbolSprites.length; i++) {
      for (var j = 0; j < this.symbolSprites.length - i - 1; j++) {
        if (this.symbolSprites[j].position.getY() > this.symbolSprites[j + 1].position.getY()) {
          var temp = this.symbolSprites[j];
          this.symbolSprites[j] = this.symbolSprites[j + 1];
          this.symbolSprites[j + 1] = temp;

          var tempData = this.symbolData[j];
          this.symbolData[j] = this.symbolData[j + 1];
          this.symbolData[j + 1] = tempData;
        }
      }
    }

    // set the symbols now all are in their new positions.
    for (var i = 0; i < 5; i++) {
      this.setSymbol(i, newSymbols[i]._id, eggMultipliers[i]);
    }

    this.reparentPoppedSymbols();

    // store the starting y positions before the drop
    for (var i = 0; i < this.symbolSprites.length; i++) {
      this.currentYPos[i] = this.symbolSprites[i].position.getY();
      this.symbolSprites[i].alpha = 1.0; // SA We must turn symbols back on here - lucky lose modifier turns them off

      this.posForOrientation[i] = undefined;
    }
  };

  reel.reparentPoppedSymbols = function () {
    for (let i = 0; i < this.symbolSprites.length; i++) {
      if (this.symbolSprites[i].droppingInFromOff === true) {
        // this symbol has popped and dropping in
        // this symbol needs to be put on the original container
        reel.reparentSymbolToOriginalParent(i);
      }
    }

    const oversizeSymbolIds = resourceManager.getConfiguration().oversizeSymbolsOrder;

    for (let s = 0; s < oversizeSymbolIds.length; s++) {
      for (let i = 0; i < this.symbolSprites.length; i++) {
        if (this.symbolData[i].symbolId === oversizeSymbolIds[s]) {
          if (this.symbolDropDeltas[i]) {
            // only reparent if we are actually going to be moving
            if (this.symbolSprites[i].droppingInFromOff) {
              reel.parentOversizedSymbolForMovement(i);
            } else {
              // moving but not a new symbol
              // does this need to be tweaked?
              reel.parentOversizedSymbolWhenStopped(i);
            }
          }
        }
      }
    }
  };

  // the original function
  reel.dropSymbols = function (delay, symbolsToPop, completeCallback) {
    // Use popSymbls before calling dropSymbols
    this.popAndDropComplete = completeCallback;

    this.dropCount = 5;

    let self = this;
    timerManager.addTimer(
      delay,
      function (progress) {},
      function () {
        // let soundIndex = Math.floor(Math.random() * reel._cascadeSounds.length);
        // soundManager.play(reel._cascadeSounds[soundIndex]);
        soundManager.play('dropSymbolsNormal');
        self.stateMachine.switchState('POP_AND_DROP');
      }
    );
  };

  reel.dropOldSymbols = function (delay, symbolsToPop, completeCallback) {
    this.popAndDropComplete = completeCallback;

    this.dropCount = 5;

    let self = this;
    timerManager.addTimer(
      delay,
      function (progress) {},
      function () {
        self.stateMachine.switchState('DROP_EXISTING');
      }
    );
  };

  reel.dropNewSymbols = function (delay, symbolsToPop, completeCallback) {
    this.popAndDropComplete = completeCallback;

    this.dropCount = 5;

    let self = this;
    timerManager.addTimer(
      delay,
      function (progress) {},
      function () {
        // let soundIndex = Math.floor(Math.random() * reel._cascadeSounds.length);
        // soundManager.play(reel._cascadeSounds[soundIndex]);
        self.stateMachine.switchState('DROP_NEW');
      }
    );
  };

  reel.playRandomDropSymbolsAnticipationSound = function () {
    let randomIndex = -1;
    let goes = 5;
    do {
      randomIndex = game.randomNumberBetween(0, reel._dropSymbolsAnticipationSounds.length - 1);
    } while (randomIndex === reel._lastRandomDropSymbolAnticipationSoundIndex && --goes > 0);
    soundManager.play(reel._dropSymbolsAnticipationSounds[randomIndex]);
    reel._lastRandomDropSymbolAnticipationSoundIndex = randomIndex;
  };

  reel.playRandomAwardEggMultiplierSound = function () {
    let randomIndex = -1;
    let goes = 5;
    do {
      randomIndex = game.randomNumberBetween(0, reel._awardEggMultiplierSounds.length - 1);
    } while (randomIndex === reel._lastRandomAwardEggMultiplierSoundIndex && --goes > 0);
    soundManager.play(reel._awardEggMultiplierSounds[randomIndex]);
    reel._lastRandomAwardEggMultiplierSoundIndex = randomIndex;
  };

  reel.popAndDrop = function (symbolsToPop, completeCallback) {
    reel.popSymbols(symbolsToPop);
    reel.dropSymbols(symbolsToPop, completeCallback);
  };

  reel.dimSymbol = function (index, dim, tint) {
    var children;
    if (dim) {
      tint = checkForDefined(tint) ? tint : 0x777777;
    } else {
      tint = 0xffffff;
    }
    // if we are in canvass don't tint show dimReelsCanvas graphic (fix for symbol switching PIXI glich in canvas renderer)
    if (systemData.renderer instanceof PIXI.CanvasRenderer) {
      this.symbolSprites[index].dimReelsCanvas.visible = tint != 0xffffff;
    } else {
      this.symbolSprites[index].symbol.tint = tint;

      if (checkForDefined(this.symbolSprites[index].symbol.childContainer)) {
        children = this.symbolSprites[index].symbol.childContainer.children;
        for (var i = 0; i < children.length; i++) {
          children[i].tint = tint;
        }
      }

      this.symbolSprites[index].symbolSparkle.tint = tint;
      this.symbolSprites[index].eggMultiplierText.tint = tint;
      this.symbolSprites[index].eggMultiplierGoldText.tint = tint;
    }
  };

  reel.dimAllSymbols = function (dim, tint) {
    for (var i = 0; i < reel.configParams.totalAppertureSize; i++) {
      reel.dimSymbol(i, dim, tint);
    }
  };

  reel.linkAnimation = function (animationStrip, animationStripID) {
    reel.linkedAnimations.push(animationStrip);
    resourceManager.setParent(animationStrip, this.animationStripContainer);
  };

  reel.linkReelBoxStrip = function (animationStrip, animationStripID) {
    reel.linkedReelBoxStrips.push(animationStrip);
    resourceManager.setParent(animationStrip, this.animationBoxContainer);
  };

  reel.updateSymbols = function (whoCalled) {
    if (whoCalled === 'onResize') {
      // we should be safe to ignore this
      return;
    }
    if (whoCalled === 'fromDrop') {
      // we should be safe to ignore this
      return;
    }

    // Set symbols
    for (var i = 0; i < reel.configParams.totalAppertureSize; i++) {
      this.symbolSprites[i].symbol.gotoAndStop(this.symbolData[i].symbolId);
    }

    // Move container
    var posOffset = 0;
    var animationStripOffset = 0;

    posOffset = (this.pos + (reel.configParams.preappertureSymbols - 1)) * reel.configParams.appertureSpacing;
    animationStripOffset = (this.pos - 1) * reel.configParams.appertureSpacing;

    //Move symbols within clip area
    this.symbolContainer.position.setY(-posOffset);
    this.interactiveSymbolContainer.scale.set(1.0, 1.0);

    // Align animation box and strip with reels
    this.animationBoxContainer.position.set(
      this.position.x * resourceManager.selectedAssetResolution.scaleFactor,
      this.position.y * resourceManager.selectedAssetResolution.scaleFactor
    );

    this.animationBoxContainer.scale.set(this.scale.x, this.scale.y);

    this.animationStripContainer.position.set(
      (this.position.x * (1.0 / this.scale.x) + this.symbolWidth * 0.5) *
        resourceManager.selectedAssetResolution.scaleFactor,
      this.position.y * (1.0 / this.scale.y) * resourceManager.selectedAssetResolution.scaleFactor -
        animationStripOffset
    );
    //this.animationStripContainer.scale.set(this.scale.x, this.scale.y);
  };

  reel.expandAnimationClipRect = function () {
    // var offsetX = (this.configParams.animationStripWidth - reel.configParams.viewportWidth) / 2;
    // var offsetY = (this.configParams.animationStripHeight - reel.configParams.viewportHeight) / 2;
    // reel.mask.clear();
    // reel.mask.beginFill(0xffff00, 0.5);
    // reel.mask.drawRect(
    //   -offsetX,
    //   -offsetY,
    //   this.configParams.animationStripWidth + 1,
    //   this.configParams.animationStripHeight + 1
    // );
    // reel.mask.endFill();
  };

  reel.restoreAnimationClipRect = function () {
    // reel.mask.clear();
    // reel.mask.beginFill(0xffff00, 0.5);
    // reel.mask.drawRect(0, 0, reel.configParams.viewportWidth + 1, reel.configParams.viewportHeight + 1);
    // reel.mask.endFill();
  };

  reel.clearReelSymbolData = function (index) {
    // Delete child from child contianer
    if (this.configParams.useContainer.child) {
      var children = this.symbolSprites[index].symbol.childContainer.children;
      while (children.length > 0) {
        resourceManager.destroyObject(children[0].name);
      }
    }
  };

  reel.setReelSymbolData = function (index, data) {
    if (typeof data === 'number') {
      data = {
        symbolId: data,
      };
    } else if (typeof data === 'string') {
      data = {
        symbolId: Number(data),
      };
    }

    if (data.childData === undefined) {
      if (this.preInjector !== undefined) {
        data.childData = this.preInjector.getSymbolChildData(data.symbolId);
      }
    }

    var configSymbols = resourceManager.getConfiguration().symbols;
    var configKeys = Object.keys(configSymbols);
    for (var i = 0; i < configKeys.length; ++i) {
      if (configSymbols[configKeys[i]].ID === data.symbolId) {
        var symbolKeys = Object.keys(configSymbols[configKeys[i]]);
        for (var j = 0; j < symbolKeys.length; ++j) {
          if (data[symbolKeys[j]] === undefined) {
            data[symbolKeys[j]] = configSymbols[configKeys[i]][symbolKeys[j]];
          }
        }
      }
    }

    if (data.oversized === undefined) data.oversized = false;

    if (data.childData !== undefined && data.childData.length > 0) {
      for (var i = 0; i < data.childData.length; ++i) {
        resourceManager.createObject(
          data.childData[i].type,
          data.childData[i].name + i,
          this.symbolSprites[index].symbol.childContainer.name,
          data.childData[i].json
        );
      }
    }
    if (data.oversized === true) {
      var symbolId = this.symbolSprites[index].symbol;
      var symbolSprite = this.symbolContainer.children.find(function (element) {
        return element.symbol === symbolId;
      });
      this.symbolContainer.setChildIndex(symbolSprite, this.symbolContainer.children.length - 1);
    }

    // Overides data and sets symbol
    this.symbolData[index] = data;
  };

  reel.symbolCreatedCallbacks = {};
  //callback = function(reelIndex, symbolId)
  reel.setAnySymbolCreatedCallback = function (callback) {
    reel.anySymbolCreatedCallback = callback;
  };

  //callback = function(reelIndex, symbolId)
  reel.setSymbolCreatedCallback = function (symbolId, callback) {
    reel.symbolCreatedCallbacks[symbolId] = callback;
  };

  reel.symbolDeletedCallbacks = {};
  //callback = function(reelIndex, symbolId)
  reel.setAnySymbolDeletedCallback = function (callback) {
    reel.anySymbolDeletedCallback = callback;
  };

  //callback = function(reelIndex, symbolId)
  reel.setSymbolDeletedCallback = function (symbolId, callback) {
    reel.symbolDeletedCallbacks[symbolId] = callback;
  };

  reel._getSymbol = function (index) {
    var defaultIndex = this.spinParams.reverseSpin ? reel.configParams.totalAppertureSize - 1 : 0;
    index = index === undefined ? defaultIndex : index;

    var container = this.symbolContainer.children.find(function (element) {
      return element.index === index;
    });
    return container;
  };

  reel.getSymbolContainer = function (index) {
    return this._getSymbol(index).symbol;
  };

  reel.getSymbolChildContainer = function (index) {
    return this._getSymbol(index).symbol.childContainer;
  };

  reel.update = function (delta) {
    this._updateDelta = delta;
    this.Props.stateTime -= delta;
    this.stateMachine.update();
  };

  reel.updatePos = cascadeReelTemplate.defaultSpin;
  reel.updateNudge = cascadeReelTemplate.nudge;
  reel.updatePopAndDrop = cascadeReelTemplate.popAndDrop;
  reel.clearSymbols = cascadeReelTemplate.clearSymbols;
  reel.dropInitialSymbols = cascadeReelTemplate.dropInitialSymbols;

  reel._updateDelta = 0.0;

  StateMachine.Create(reel);

  // 'READY'
  reel.stateMachine.addState(
    'READY',
    function state_ready() {
      if (this.phase.enter()) {
        // reels are idle
        // this is where we start a random timer
        // when the timer has expired, pick a random amount of gems to sparkle
        // then sparkle them
        // need to keep a count of whats sparkling etc
        // so when spin is pressed, we can stop them or when you get a win, we can stop them
        this.startRandomSparkleTimer();
        this.startRandomWildTimer();
      }
    }.bind(reel)
  );

  // 'DROP_EXISTING'
  reel.stateMachine.addState(
    'DROP_EXISTING',
    function state_dropExisting() {
      if (this.phase.enter()) {
        reel.stopSparklesTimer();
        reel.stopWildTimer();
      }

      // we need to drop the symbols off one by one
      if (this.phase.once()) {
        let gap = freespins.inFreespins ? this.configParams.gapBetweenSymbolsFS : this.configParams.gapBetweenSymbols;

        // no anticipation when dropping existing
        this.popDropSymbol(0 * gap, 4, 'old');
        this.popDropSymbol(1 * gap, 3, 'old');
        this.popDropSymbol(2 * gap, 2, 'old');
        this.popDropSymbol(3 * gap, 1, 'old');
        this.popDropSymbol(4 * gap, 0, 'old');
      }

      if (this.phase.hold()) {
        if (this.dropCount === 0) {
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        // what state do we switch to after?
        this.dropCount = 5;
        this.stateMachine.switchState('READY');
      }
      if (this.phase.exit()) {
        this.updateSymbols('fromDrop');
        this.popAndDropComplete(this.reelIndex, true);
      }
    }.bind(reel)
  );

  // DROP_NEW
  reel.stateMachine.addState(
    'DROP_NEW',
    function state_dropNew() {
      // we need to drop the symbols off one by one
      if (this.phase.once()) {
        let gap = freespins.inFreespins ? this.configParams.gapBetweenSymbolsFS : this.configParams.gapBetweenSymbols;

        // increase gap if we are anticipating?
        if (
          gameController.startAnticipationDelayFromReel !== -2 &&
          this.reelIndex > gameController.startAnticipationDelayFromReel
        ) {
          // we cant have longer on the last one
          // unless we double check the drop delays as well
          // plus do we also need to see if its a colossal ?
          //
          const gapMultiplier = resourceManager.getConfiguration().anticipationConfig.gapMultiplier;
          gap *= gapMultiplier;
        }

        this.popDropSymbol(0 * gap, 4, 'new');
        this.popDropSymbol(1 * gap, 3, 'new');
        this.popDropSymbol(2 * gap, 2, 'new');
        this.popDropSymbol(3 * gap, 1, 'new');
        this.popDropSymbol(4 * gap, 0, 'new');
      }

      if (this.phase.hold()) {
        if (this.dropCount === 0) {
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        this.stateMachine.switchState('READY');
      }
      if (this.phase.exit()) {
        this.updateSymbols('fromDrop');
        this.popAndDropComplete(this.reelIndex);
      }
    }.bind(reel)
  );

  // POP_AND_DROP
  reel.stateMachine.addState(
    'POP_AND_DROP',
    function state_popanddrop() {
      if (this.phase.enter()) {
        reel.stopSparklesTimer();
        reel.stopWildTimer();
      }

      // we need to drop the symbols off one by one
      if (this.phase.once()) {
        let gap = freespins.inFreespins ? this.configParams.gapBetweenSymbolsFS : this.configParams.gapBetweenSymbols;

        // increase gap if we are anticipating?
        if (
          gameController.startAnticipationDelayFromReel !== -2 &&
          this.reelIndex > gameController.startAnticipationDelayFromReel
        ) {
          // we cant have longer on the last one
          // unless we double check the drop delays as well
          // plus do we also need to see if its a colossal ?
          //
          const gapMultiplier = resourceManager.getConfiguration().anticipationConfig.gapMultiplier;
          gap *= gapMultiplier;
        }

        // before we do this
        // have a look to see if any new golden eggs are below the minimum
        if (freespins.inFreespins) {
          const _bgTrail = resourceManager.get('bgTrail:BGTrailContainer');
          const minMultiplier = _bgTrail.getMinMultiplier();
          for (let i = 0; i < 5; i++) {
            if (
              this.symbolSprites[i].droppingInFromOff === true &&
              (this.symbolData[i].symbolId === 20 || this.symbolData[i].symbolId === 21)
            ) {
              // this is a new egg symbol
              // lets just make sure the multiplier on the egg matches the min
              if (this.symbolData[i].eggMultiplier < minMultiplier) {
                this.forceEggSymbolMultiplier(i, minMultiplier);
              }
            }
          }
        }

        this.popDropSymbol(0 * gap, 4);
        this.popDropSymbol(1 * gap, 3);
        this.popDropSymbol(2 * gap, 2);
        this.popDropSymbol(3 * gap, 1);
        this.popDropSymbol(4 * gap, 0);
      }

      if (this.phase.hold()) {
        if (this.dropCount === 0) {
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        this.stateMachine.switchState('READY');
      }
      if (this.phase.exit()) {
        this.updateSymbols('fromDrop');
        this.popAndDropComplete(this.reelIndex);
      }
    }.bind(reel)
  );

  reel.reparentAllSymbolsToOriginalParents = function () {
    for (let i = 0; i < this.symbolSprites.length; i++) {
      reel.reparentSymbolToOriginalParent(i);
    }
  };

  reel.reparentSymbolToOriginalParent = function (index) {
    const sprite = this.symbolSprites[index];
    if (sprite.parent !== sprite.originalParent) {
      sprite.originalParent.addChild(sprite);
    }
  };

  reel.parentAllOversizedSymbols = function (fromIndex = 0, forceStopped = false, whatSymbols = 'all') {
    const oversizeSymbolIds = resourceManager.getConfiguration().oversizeSymbolsOrder;

    for (let s = 0; s < oversizeSymbolIds.length; s++) {
      for (let i = fromIndex; i < this.symbolSprites.length; i++) {
        if (this.symbolData[i].symbolId === oversizeSymbolIds[s]) {
          let waitingToDropStill = false;
          if (forceStopped === true && whatSymbols === 'old') {
            // before we do it
            // check whatSymbols, as we may only be dropping old ones
            if (this.symbolSprites[i].droppingInFromOff === true) {
              // symbols still waiting to drop in
              waitingToDropStill = true;
            }
          }
          if ((forceStopped || !this.symbolDropDeltas[i]) && !waitingToDropStill) {
            // symbol isnt moving, so it can stay where it is - well on the unmasked container
            reel.parentOversizedSymbolWhenStopped(i);
          } else {
            reel.parentOversizedSymbolForMovement(i);
          }
        }
      }
    }
  };

  reel.parentOversizedSymbolForMovement = function (index) {
    if (!this.oversizedContainer) {
      const oversizedSymbolContainer = resourceManager.get(`slotContainer:oversizedSymbolContainer`);
      if (!oversizedSymbolContainer.mask) {
        // this also needs to be masked
        oversizedSymbolContainer.mask = new PIXI.Graphics();
        oversizedSymbolContainer.mask.beginFill(0xff0000, 1);
        oversizedSymbolContainer.mask.drawRect(0, 75, 890, 550);
        oversizedSymbolContainer.mask.endFill();
        oversizedSymbolContainer.addChild(oversizedSymbolContainer.mask);
      }

      this.oversizedContainer = resourceManager.get(`slotContainer:oversizedSymbolContainer:osc${this.reelIndex}`);
      this.oversizedContainer.x += this.symbolContainer.x;
      this.oversizedContainer.y += this.symbolContainer.y;
    }
    const symbolSprite = this.symbolSprites[index];
    const currentParent = this.symbolSprites[index].parent;
    // if (currentParent !== this.oversizedContainer) {
    this.oversizedContainer.addChild(symbolSprite);
    // }
  };

  reel.parentOversizedSymbolWhenStopped = function (index) {
    if (!this.oversizedContainerNonMasked) {
      this.oversizedContainerNonMasked = resourceManager.get(
        `slotContainer:oversizedSymbolNonMaskedContainer:osc${this.reelIndex}`
      );
      this.oversizedContainerNonMasked.x += this.symbolContainer.x;
      this.oversizedContainerNonMasked.y += this.symbolContainer.y;
    }
    const symbolSprite = this.symbolSprites[index];
    const currentParent = this.symbolSprites[index].parent;
    // if (currentParent !== this.oversizedContainerNonMasked) {
    // no need to save the original parent at this point
    // as one will already be there
    this.oversizedContainerNonMasked.addChild(symbolSprite);
    // }
  };

  reel.resetEggMultiplierData = function () {
    for (let i = 0; i < this.symbolSprites.length; i++) {
      this.symbolSprites[i].eggMultiplier = 1;
    }
  };

  // CLEAR_SYMBOLS
  reel.stateMachine.addState(
    'CLEARSYMBOLS',
    function state_clearSymbols() {
      if (this.phase.enter()) {
        reel.stopSparklesTimer();
        reel.stopWildTimer();

        // this is where we need to put the symbols on the appropriate container
        reel.reparentAllSymbolsToOriginalParents();
        reel.parentAllOversizedSymbols();
      }

      // we need to drop the symbols off one by one
      if (this.phase.once()) {
        let gap = freespins.inFreespins ? this.configParams.gapBetweenSymbolsFS : this.configParams.gapBetweenSymbols;
        this.clearSymbol(0 * gap, 4);
        this.clearSymbol(1 * gap, 3);
        this.clearSymbol(2 * gap, 2);
        this.clearSymbol(3 * gap, 1);
        this.clearSymbol(4 * gap, 0);
      }

      if (this.phase.hold()) {
        if (this.dropCount === 0) {
          this.phase.step();
        }
      }

      if (this.phase.once()) {
        this.resetEggMultiplierData();
        this.stateMachine.switchState('READY');
      }
      if (this.phase.exit()) {
        this.spinning = false;

        this.stopSparkles();
        this.stopWildIdles();

        this.initialDropCompleteCallback(this.reelIndex);
      }
    }.bind(reel)
  );

  reel.createLandAnimForSymbolId = function (symbolID) {
    let landAnim = null;

    // not to be in HERE!!!!
    const movieDefs = [
      null, //'BlueBeanLand_md',
      null, //'GreenBeanLand_md',
      null, //'PurpleBeanLand_md',
      null, //'RedBeanLand_md',
      null, //'YellowBeanLand_md',
      null, //'GreenGemLand_md',
      null, //'PurpleGemLand_md',
      null, //'RedGemLand_md',
      null, //'YellowGemLand_md',
      null, //'WildLand_md',
      'BonusLand_md',
      null, // fake
      null, // fake
      null, // fake
      null, // fake
      null, // fake
      null, // fake
      null, // fake
      null, // fake
      null, // fake
      null, //'GoldenEggSmallLand_md',
      null, //'GoldenEggLargeLand_md',
    ];

    if (typeof reel.landAnimsCreated[symbolID] === 'undefined') {
      reel.landAnimsCreated[symbolID] = 0;
    } else {
      reel.landAnimsCreated[symbolID]++;
    }
    // create unique id
    const id = `landAnim_${this.reelIndex}_${symbolID}_${reel.landAnimsCreated[symbolID]}`;
    // get name of container we want to add this to
    // just so i can create the damn thing
    const tempContainerName = 'slotContainer:foregroundReelSymbols';
    landAnim = resourceManager.createObject('movie', id, tempContainerName, {
      x: 0,
      y: 0,
      anchor: 0.5,
      definition: movieDefs[symbolID],
      loop: false,
    });

    // remove from stage
    landAnim.parent.removeChild(landAnim);

    return landAnim;
  };

  reel.getLandAnimForSymbolId = function (symbolID) {
    if (typeof this.landAnimPool[symbolID] === 'undefined') {
      this.landAnimPool[symbolID] = [];
    }

    if (this.landAnimPool[symbolID].length === 0) {
      // need to create one 1st
      // add it to the pool
      // we should never get to a point where we have too many
      this.addLandAnimToPool(this.createLandAnimForSymbolId(symbolID), symbolID);
    }

    const landAnim = this.landAnimPool[symbolID].pop();
    return landAnim;
  };

  reel.addLandAnimToPool = function (landAnim, symbolID) {
    this.landAnimPool[symbolID].push(landAnim);
  };

  reel.playLandAnim = async function (data) {
    const { symbolIndex, symbolId, loop } = data;
    // create movie or pull from pool?
    const landAnim = this.getLandAnimForSymbolId(symbolId);

    // just so we can get a reference to the land anim
    // without needing to restructure this function
    data.landAnim = landAnim;

    // add to scene
    const symbol = this.symbolSprites[symbolIndex].symbol;
    const sparkle = this.symbolSprites[symbolIndex].symbolSparkle;
    const parent = symbol.parent;
    sparkle.renderable = false;
    const symbolChildIndex = parent.getChildIndex(symbol);
    parent.addChildAt(landAnim, symbolChildIndex + 1);
    // hide normal
    symbol.renderable = false;
    // play
    landAnim.x = symbol.x;
    landAnim.y = symbol.y;
    if (loop === true) {
      await game.loopMovie(landAnim, data.fromFrame);
    } else {
      await game.playMovie(landAnim);
    }

    // remove and put back into pool
    parent.removeChild(landAnim);
    this.addLandAnimToPool(landAnim, symbolId);
    // and show previous
    symbol.renderable = true;
    sparkle.renderable = true;
  };

  reel.popDropSymbol = function (timeBetweenSymbols, symbolIndex, whatSymbols = 'all') {
    let self = this;
    let dropTime = this.configParams.popAndDropTime;

    timerManager.addTimer(
      timeBetweenSymbols,
      function (progress) {},
      function () {
        // self.parentAllOversizedSymbols(symbolIndex);
        if (whatSymbols === 'new') {
          if (self.symbolSprites[symbolIndex].droppingInFromOff === true) {
            reel.playRandomDropSymbolsAnticipationSound();
          }
        }
        timerManager.addTimer(
          dropTime,
          function (progress) {
            self.updatePopAndDrop(symbolIndex, progress, whatSymbols);
          },
          function () {
            self._droppedCallback(self.reelIndex, symbolIndex, whatSymbols);
            self.dropCount--;
            self.parentAllOversizedSymbols(symbolIndex, true, whatSymbols);
            self.updatePopAndDrop(symbolIndex, 1, whatSymbols);
          }
        );
      }
    );
  };

  reel.clearSymbol = function (timeBetweenSymbols, symbolIndex) {
    let self = this;
    let dropTime = freespins.inFreespins ? this.configParams.dropAllTimeFS : this.configParams.dropAllTime;

    // i have added a check for de, but the adjustments work well for
    // license pt as well
    const license = gameData.license.toUpperCase();
    if (license === 'DE') {
      const minGameTime = gdk.minGameTime;
      if (minGameTime > 2) {
        let multiplier = minGameTime * 0.5;
        // do we want to cap the multiplier? YES!
        if (multiplier > 1.75) {
          multiplier = 1.75;
        }
        timeBetweenSymbols *= multiplier;
        dropTime *= multiplier;
      }
    }

    self.clearTimer[symbolIndex] = timerManager.addTimer(
      timeBetweenSymbols,
      function (progress) {},
      function () {
        self.clearSymTimer[symbolIndex] = timerManager.addTimer(
          dropTime,
          function (progress) {
            self.clearSymbols(symbolIndex, progress);
          },
          function () {
            self.dropCount--;
            self.clearSymbols(symbolIndex, 1);
          }
        );
      }
    );
  };

  reel.dropSymbol = function (timeBetweenSymbols, symbolIndex) {
    // this is the initial drop of symbols after the reels are cleared away
    let self = this;
    let dropTime = freespins.inFreespins ? this.configParams.dropAllTimeFS : this.configParams.dropAllTime;

    // i have added a check for de, but the adjustments work well for
    // license pt as well
    const license = gameData.license.toUpperCase();
    if (license === 'DE') {
      const minGameTime = gdk.minGameTime;
      if (minGameTime > 2) {
        let multiplier = minGameTime * 0.5;
        // do we want to cap the multiplier? YES!
        if (multiplier > 1.5) {
          multiplier = 1.5;
        }
        timeBetweenSymbols *= multiplier;
        dropTime *= multiplier;
      }
    }

    self.symTimer[symbolIndex] = timerManager.addTimer(
      timeBetweenSymbols,
      function (progress) {},
      function () {
        // self.parentAllOversizedSymbols(symbolIndex);
        self.dropInitialTimer[symbolIndex] = timerManager.addTimer(
          dropTime,
          function (progress) {
            self.dropInitialSymbols(symbolIndex, progress);
          },
          function () {
            self.parentAllOversizedSymbols(symbolIndex, true);
            self.dropInitialSymbols(symbolIndex, 1);

            // we don't need to worry about the bottom most symbol as that never lands on screen
            // if (symbolIndex !== 3) {
            self._landedCallback(self.reelIndex, symbolIndex);
            // }

            // do drop count after callback to ensure any anims have been started
            self.dropCount--;
          }
        );
      }
    );
  };

  reel.playLandSound = function (force = false) {
    if ((force || !this.landSoundPlayed) && this.spinParams.landSound) {
      this.landSoundPlayed = true;
      soundManager.play(this.spinParams.landSound);
    }
  };

  reel.stateMachine.addState(
    'DROPINITIALSYMBOLS',
    function state_dropInitialSymbols() {
      if (this.phase.enter()) {
        this.landSoundPlayed = false;
      }

      // ?? allowDrop = [true, false, false ];

      // we need to drop the symbols off one by one
      if (this.phase.once()) {
        let gap = freespins.inFreespins ? this.configParams.gapBetweenSymbolsFS : this.configParams.gapBetweenSymbols;

        // increase gap if we are anticipating?
        if (
          gameController.startAnticipationDelayFromReel !== -2 &&
          this.reelIndex > gameController.startAnticipationDelayFromReel
        ) {
          // we cant have longer on the last one
          // unless we double check the drop delays as well
          // plus do we also need to see if its a colossal ?
          //
          const gapMultiplier = resourceManager.getConfiguration().anticipationConfig.gapMultiplier;
          gap *= gapMultiplier;
        }

        this.dropSymbol(0 * gap, 4);
        this.dropSymbol(1 * gap, 3);
        this.dropSymbol(2 * gap, 2);
        this.dropSymbol(3 * gap, 1);
        this.dropSymbol(4 * gap, 0);
      }

      if (this.phase.hold()) {
        if (this.dropCount === 0) {
          this.playLandSound();

          this.phase.step();
        }
      }

      if (this.phase.once()) {
        this.stateMachine.switchState('READY');
      }

      // Make sure the callback handler checks that we haven't already been invoked
      // in this case it works by setting boolean flags rather than a count that can be
      // decremented too many times
      if (this.phase.once()) {
        this.spinning = false;
        this.spinCompleteCallback(this.reelIndex);
      }
    }.bind(reel)
  );

  reel.onOrientationChange = function () {
    // shouldnt need to worry about this
    // for (var i = 0; i < this.symbolSprites.length; i++) {
    //   if (reel.posForOrientation[i] !== undefined) {
    //     this.symbolSprites[i].position.setY(reel.posForOrientation[i]);
    //   }
    // }
    if (reel._moveMultiplierTextTweenInfo.tween && reel._moveMultiplierTextTweenInfo.tween.isActive()) {
      // should make the tween finish early
      reel._moveMultiplierTextTweenInfo.tween.progress(1);
    }
    if (reel._moveGoldMultiplierTextTweenInfo.tween && reel._moveGoldMultiplierTextTweenInfo.tween.isActive()) {
      // should make the tween finish early
      reel._moveGoldMultiplierTextTweenInfo.tween.progress(1);
    }
    if (reel._scaleMultiplierTextTweenInfo.tween && reel._scaleMultiplierTextTweenInfo.tween.isActive()) {
      // should make the tween finish early
      reel._scaleMultiplierTextTweenInfo.tween.progress(1);
    }
    if (reel._scaleGoldMultiplierTextTweenInfo.tween && reel._scaleGoldMultiplierTextTweenInfo.tween.isActive()) {
      // should make the tween finish early
      reel._scaleGoldMultiplierTextTweenInfo.tween.progress(1);
    }
  };

  reel.randomNumberBetween = function (min, max) {
    return game.randomNumberBetween(min, max);
  };

  reel.stopSparkle = function (sparkle) {
    if (sparkle.rotateTweenInfo) {
      if (sparkle.rotateTweenInfo.tween.isActive()) {
        sparkle.rotateTweenInfo.tween.progress(1);
      }
    }
    if (sparkle.scaleTweenInfo) {
      if (sparkle.scaleTweenInfo.tween.isActive()) {
        sparkle.scaleTweenInfo.tween.progress(1);
      }
    }
    sparkle.visible = false;
  };

  reel.stopSparklesTimer = function () {
    if (this._sparkleTimer) {
      timerManager.stop(this._sparkleTimer);
      this._sparkleTimer = null;
    }
  };

  reel.stopWildIdle = function (wildIdleMovie) {
    if (wildIdleMovie && wildIdleMovie.visible === true) {
      wildIdleMovie.gotoAndStop(0);
      const parent = wildIdleMovie.parent;
      parent.removeChild(wildIdleMovie);
      wildIdleMovie.onComplete = null;
      wildIdleMovie.masterSymbol.visible = true;
    }
    wildIdleMovie.visible = false;
  };

  reel.stopWildTimer = function () {
    if (this._wildTimer) {
      timerManager.stop(this._wildTimer);
      this._wildTimer = null;
    }
  };

  reel.stopSparkles = function () {
    reel.stopSparklesTimer();

    for (let i = 0; i < this.symbolSprites.length; i++) {
      const sparkle = this.symbolSprites[i].symbolSparkle;
      this.stopSparkle(sparkle);
    }
  };

  reel.stopWildIdles = function () {
    reel.stopWildTimer();

    for (let i = 0; i < this.symbolSprites.length; i++) {
      const wildIdleMovie = this.symbolSprites[i].wildIdleMovie;
      this.stopWildIdle(wildIdleMovie);
    }
  };

  reel.animateSparkle = async function (symbolSparkle, symbol) {
    symbolSparkle.tint = symbol.tint;
    symbol.addChild(symbolSparkle);
    symbolSparkle.visible = true;
    if (!symbolSparkle.rotateTweenInfo) {
      symbolSparkle.rotateTweenInfo = {};
    }
    if (!symbolSparkle.scaleTweenInfo) {
      symbolSparkle.scaleTweenInfo = {};
    }

    const rotatePromise = game.tweenFromToAsync(
      symbolSparkle,
      {
        rotation: 0,
      },
      {
        rotation: Math.PI * 2,
        repeat: 1,
        duration: 0.5,
        ease: 'none',
      },
      symbolSparkle.rotateTweenInfo
    );

    const scalePromise = game.tweenFromToAsync(
      symbolSparkle.scale,
      {
        x: 0,
        y: 0,
      },
      {
        x: 1.5,
        y: 1.5,
        yoyo: true,
        repeat: 1,
        duration: 0.5,
      },
      symbolSparkle.scaleTweenInfo
    );

    await Promise.all([rotatePromise, scalePromise]);

    symbolSparkle.visible = false;
    symbol.removeChild(symbolSparkle);
  };

  reel.playSparklesIfRequired = function () {
    let gemsFound = false;
    for (let i = 0; i < this.symbolSprites.length; i++) {
      const symbol = this.symbolSprites[i].symbol;
      const sparkle = this.symbolSprites[i].symbolSparkle;
      let coords = this._sparkleCoords[this.symbolData[i].symbolId];
      if (symbol.colossal === 2) {
        // 2x2
        coords = this._sparkleCoords2x2[this.symbolData[i].symbolId];
      } else if (symbol.colossal === 3) {
        // 3x3
        // shouldnt we just ignore for 3x3 as these will be converted
        coords = null; //this._sparkleCoords3x3[this.symbolData[i].symbolId];
      }

      if (coords) {
        if (sparkle.visible !== true) {
          // do we want to start the sparkle anim on this symbol?
          const random = reel.randomNumberBetween(0, 5);
          if (random === 0) {
            sparkle.x = coords.x - 130 / 2;
            sparkle.y = coords.y - 110 / 2;
            this.animateSparkle(sparkle, symbol);
          }
        } else {
          // already animating
          // try again next time
        }
        gemsFound = true;
      }
    }
    // are there any gems on this reel?
    if (gemsFound === true) {
      this.startRandomSparkleTimer();
    } else {
      // no gems found on this reel, no point restarting the timer
    }
  };

  reel.playWildIdlesIfRequired = function () {
    let wildsFound = false;
    var wildID = resourceManager.getConfiguration().symbols['Wild'].ID;
    const sp = gdk.getServerParser();
    for (let i = 0; i < this.symbolSprites.length; i++) {
      const symbolSprite = this.symbolSprites[i];
      const symbolData = this.symbolData[i];
      if (symbolData.symbolId === wildID) {
        const random = reel.randomNumberBetween(0, 1);
        if (sp._inGame === false && random === 0 && symbolSprite.wildIdleMovie.visible === false) {
          const symbol = symbolSprite.symbol;
          const symbolParent = symbol.parent;
          const symbolChildIndex = symbolParent.getChildIndex(symbol);
          symbolParent.addChildAt(symbolSprite.wildIdleMovie, symbolChildIndex + 1);
          symbolSprite.wildIdleMovie.onComplete = () => {
            this.stopWildIdle(symbolSprite.wildIdleMovie);
          };
          symbolSprite.wildIdleMovie.masterSymbol = symbol;
          symbolSprite.wildIdleMovie.masterSymbol.visible = false;
          symbolSprite.wildIdleMovie.gotoAndPlay(0);
          symbolSprite.wildIdleMovie.visible = true;
        }
        wildsFound = true;
      } else {
        // not a wild symbol
      }
    }
    // are there any magic beans on this reel?
    if (wildsFound === true) {
      this.startRandomWildTimer();
    } else {
    }
  };

  reel.startRandomSparkleTimer = function () {
    let randomDelayInMS = reel.randomNumberBetween(3, 5) * 1000; //(Math.floor(Math.random() * 3) + 2) * 1000; // 2000 to 5000ms
    //
    this._sparkleTimer = timerManager.addTimer(randomDelayInMS, undefined, () => {
      this.playSparklesIfRequired();
    });
  };

  reel.startRandomWildTimer = function () {
    let randomDelayInMS = reel.randomNumberBetween(2, 3) * 1000; //(Math.floor(Math.random() * 3) + 2) * 1000; // 2000 to 5000ms
    //
    this._wildTimer = timerManager.addTimer(randomDelayInMS, undefined, () => {
      this.playWildIdlesIfRequired();
    });
  };

  reel.upgradeFSEggMultiplier = async function (index, minMultiplier) {
    if (!this.eggUpgradeContainer) {
      this.eggUpgradeContainer = resourceManager.get(`slotContainer:eggUpgradeContainer:euc${this.reelIndex}`);
      this.eggUpgradeContainer.x += this.symbolContainer.x;
      this.eggUpgradeContainer.y += this.symbolContainer.y;
    }

    const symbolSprite = reel.symbolSprites[index];
    const symbolData = reel.symbolData[index];
    const origParent = symbolSprite.parent;
    const origIndex = origParent.getChildIndex(symbolSprite);
    console.log('upgrading egg original child index was ' + origIndex);

    // could do with finding the child id also
    symbolSprite.symbol.addChild(symbolSprite.eggAwardSparksMovie);
    this.eggUpgradeContainer.addChild(symbolSprite);

    soundManager.play('fsEggUpgrade');
    const moviePromise = game.playMovie(symbolSprite.eggAwardSparksMovie);

    await timerManager.delayAsync(250);

    // we probably want to move the symbol from 1 parent to another
    // make sure its drawn over everything
    symbolSprite.eggMultiplier = minMultiplier;
    symbolSprite.eggMultiplierText.setText(`${minMultiplier}x`);
    symbolSprite.eggMultiplierGoldText.setText(`${minMultiplier}x`);

    let symbol = symbolData.symbolId;
    if (minMultiplier >= 20) {
      symbol = 21;
      symbolSprite.eggMultiplierText.visible = false;
      symbolSprite.eggMultiplierGoldText.visible = true;
    } else {
      symbolSprite.eggMultiplierText.visible = true;
      symbolSprite.eggMultiplierGoldText.visible = false;
    }

    symbolSprite.symbol.gotoAndStop(symbol);
    symbolData.symbolId = symbol;

    await moviePromise;
    symbolSprite.symbol.removeChild(symbolSprite.eggAwardSparksMovie);
    origParent.addChildAt(symbolSprite, origIndex);

    // but did we need to upgrade the egg from small to large?
    // the order is slightly different
    // do we really need to worry about it?
  };

  reel.awardFSEggMultiplier = async function (index) {
    if (!this.eggAwardContainer) {
      this.eggAwardContainer = resourceManager.get(`slotContainer:eggAwardContainer:eac${this.reelIndex}`);
      this.eggAwardContainer.x += this.symbolContainer.x;
      this.eggAwardContainer.y += this.symbolContainer.y;
    }

    const symbolSprite = reel.symbolSprites[index];
    const origParent = symbolSprite.parent;
    const origIndex = origParent.getChildIndex(symbolSprite);

    this.eggAwardContainer.addChild(symbolSprite);

    // we need to move the multiplier from the egg, to the panel
    // once at the panel update the text
    // work out the final x and y pos
    // x 323 y : -425
    const freeSpinsTotalWinPanel = resourceManager.get(
      'slotContainer:freeSpinsTotalWinPanelContainer:FreeSpinsTotalWinPanel'
    );

    const symbol = symbolSprite.symbol;
    const symbolParent = symbol.parent;
    const symbolChildIndex = symbolParent.getChildIndex(symbol);
    // what egg are we? small or large?
    const eggAnim = symbolSprite.eggMultiplier >= 20 ? symbolSprite.largeEggWinMovie : symbolSprite.smallEggWinMovie;
    const repeat = symbolSprite.eggMultiplier === 1000 ? 4 : 2;
    const duration = symbolSprite.eggMultiplier === 1000 ? 0.166 : 0.333;
    symbolParent.addChildAt(eggAnim, symbolChildIndex + 1);
    symbolParent.addChildAt(symbolSprite.eggBurst, symbolChildIndex + 1);

    // before we do anything - play new egg win animation
    // not sure we care about the promise returned?

    reel.playRandomAwardEggMultiplierSound();
    symbol.visible = false;
    const eggAnimPromise = game.playMovie(eggAnim);
    // and scale the multiplier
    const scaleMultiplierTextPromise = game.tweenFromToAsync(
      symbolSprite.eggMultiplierText.scale,
      {
        x: symbolSprite.eggMultiplierText.scale.x,
        y: symbolSprite.eggMultiplierText.scale.y,
      },
      {
        x: symbolSprite.eggMultiplierText.scale.x * 1.5,
        y: symbolSprite.eggMultiplierText.scale.y * 1.5,
        yoyo: true,
        repeat: repeat,
        duration: duration,
      }
    );
    const scaleMultiplierGoldTextPromise = game.tweenFromToAsync(
      symbolSprite.eggMultiplierGoldText.scale,
      {
        x: symbolSprite.eggMultiplierGoldText.scale.x,
        y: symbolSprite.eggMultiplierGoldText.scale.y,
      },
      {
        x: symbolSprite.eggMultiplierGoldText.scale.x * 1.5,
        y: symbolSprite.eggMultiplierGoldText.scale.y * 1.5,
        yoyo: true,
        repeat: repeat,
        duration: duration,
      }
    );

    // now we need a bit of a delay before we bring in the egg burst
    await timerManager.delayAsync(500);

    // fade in and rotate the egg burst
    symbolSprite.eggBurst.visible = true;
    symbolSprite.eggBurst.scale.set(0.8);
    symbolSprite.eggBurst.alpha = 0;
    const rotateEggBurstTween = gsap.fromTo(
      symbolSprite.eggBurst,
      {
        rotation: 0,
      },
      {
        rotation: Math.PI * 2,
        repeat: -1,
        duration: 3,
        ease: 'none',
        paused: false,
        immediateRender: false,
      }
    );

    gsap.fromTo(
      symbolSprite.eggBurst,
      {
        alpha: 0,
      },
      {
        alpha: 0.9,
        duration: 0.5,
        ease: 'none',
        paused: false,
        immediateRender: false,
      }
    );

    await Promise.all([freeSpinsTotalWinPanel.moveValue(symbolSprite.eggMultiplier), timerManager.delayAsync(500)]);

    // instead of using the multiplier panel, i think we should use the multiplierText to create our
    // go to position
    const multiplierText = resourceManager.get(
      'slotContainer:freeSpinsTotalWinPanelContainer:FreeSpinsTotalWinPanel:textContainer:combinedTextContainer:multiplierContainer:multiplierText'
    );

    const stage = systemData.stage;
    const globalPos = freeSpinsTotalWinPanel._multiplierText.toGlobal(stage);
    const globalPosGold = freeSpinsTotalWinPanel._multiplierText.toGlobal(stage);
    const newPosForText = symbolSprite.eggMultiplierText.parent.toLocal(globalPos);
    const newPosForGoldText = symbolSprite.eggMultiplierGoldText.parent.toLocal(globalPosGold);

    // move the multiplier etc
    await Promise.all([
      game.tweenFromToAsync(
        symbolSprite.eggMultiplierText.scale,
        {
          x: symbolSprite.eggMultiplierText.scale.x,
          y: symbolSprite.eggMultiplierText.scale.y,
        },
        {
          x: symbolSprite.eggMultiplierText.scale.x * 0.6,
          y: symbolSprite.eggMultiplierText.scale.y * 0.6,
          duration: 1,
        },
        reel._scaleMultiplierTextTweenInfo
      ),
      game.tweenFromToAsync(
        symbolSprite.eggMultiplierGoldText.scale,
        {
          x: symbolSprite.eggMultiplierGoldText.scale.x,
          y: symbolSprite.eggMultiplierGoldText.scale.y,
        },
        {
          x: symbolSprite.eggMultiplierGoldText.scale.x * 0.6,
          y: symbolSprite.eggMultiplierGoldText.scale.y * 0.6,
          duration: 1,
        },
        reel._scaleGoldMultiplierTextTweenInfo
      ),
      game.tweenFromToAsync(
        symbolSprite.eggMultiplierText,
        {
          x: 0,
          y: 0,
        },
        {
          x: newPosForText.x,
          y: newPosForText.y,
          duration: 1,
          ease: 'power1.in',
        },
        reel._moveMultiplierTextTweenInfo
      ),
      game.tweenFromToAsync(
        symbolSprite.eggMultiplierGoldText,
        {
          x: 0,
          y: 0,
        },
        {
          x: newPosForGoldText.x,
          y: newPosForGoldText.y,
          duration: 1,
          ease: 'power1.in',
        },
        reel._moveGoldMultiplierTextTweenInfo
      ),
    ]);

    symbolSprite.eggMultiplierText.x = 0;
    symbolSprite.eggMultiplierText.y = 0;
    symbolSprite.eggMultiplierGoldText.x = 0;
    symbolSprite.eggMultiplierGoldText.y = 0;

    symbolSprite.eggMultiplierText.setText('');
    symbolSprite.eggMultiplierGoldText.setText('');

    freeSpinsTotalWinPanel.addMultiplier(symbolSprite.eggMultiplier);

    // now lets fade in the original symbol
    // fade out the burst
    symbol.visible = true;
    symbol.alpha = 0;

    await Promise.all([
      game.tweenFromToAsync(
        symbolSprite.eggBurst,
        {
          alpha: 0.9,
        },
        {
          alpha: 0,
          duration: 0.25,
          ease: 'none',
        }
      ),
      game.tweenFromToAsync(
        symbol,
        {
          alpha: 0,
        },
        {
          alpha: 1,
          duration: 0.25,
          ease: 'none',
        }
      ),
    ]);

    rotateEggBurstTween.kill();
    symbolSprite.eggBurst.visible = false;
    symbolParent.removeChild(eggAnim);
    symbolParent.removeChild(symbolSprite.eggBurst);

    // await timerManager.delayAsync(750);

    // put the egg back at the same place as before
    origParent.addChildAt(symbolSprite, origIndex);
  };

  Reflex.registerEventHandler('orientationChange', reel.onOrientationChange.bind(reel));

  reel.stateMachine.switchState('READY');

  return reel;
};
